import { addClass } from 'element-ui/src/utils/dom'
const failedDirective = {}

failedDirective.install = (Vue) => {
  const assetIMG = require('@/assets/img/placeholder-image-white.jpg')
  // TODO: Add placeholder video
  const assetVIDEO = require('@/assets/img/placeholder-image-white.jpg')

  const IMG = 'IMG'
  // const VIDEO = 'VIDEO'
  // const SOURCE = 'SOURCE'

  const failed = (el, binding) => {
    // Exepected items in binding.value
    // isFailed --- blocks replacement of src when is false
    // class -- adds class when image has failed
    // call -- calls a function when image has failed

    if (el.tagName !== IMG) return

    var callback = el.onerror

    el.onerror = function (event) {
      try {
        // SET Failed class on item if exists
        var styleClass = (binding.value && binding.value.class) || ''

        // Block replacement of src
        var isFailed = typeof binding.value !== 'object' || typeof binding.value.isFailed === 'undefined' || binding.value.isFailed

        if (isFailed) {
          if (styleClass) {
            addClass(el, styleClass)
          }

          // SET Holder
          el.src = el.tagName === IMG ? assetIMG : assetVIDEO
        }
      } catch (e) {
        console.warn(e.message)
      }

      // Continue execution of old function
      if (typeof callback === 'function') {
        callback(event)
      }
      // Call any action after
      if (binding.value && typeof binding.value.call === 'function') {
        binding.value.call()
      }
    }
  }

  Vue.directive('media-failed', {
    bind: function (el, binding) {
      failed(el, binding)
    },

    update: function (el, binding) {
      failed(el, binding)
    },

    unbind: function () {},
  })
}

export default failedDirective
